import { render, staticRenderFns } from "./TrustPilot.vue?vue&type=template&id=7698e7ca&scoped=true&"
import script from "./TrustPilot.vue?vue&type=script&lang=ts&"
export * from "./TrustPilot.vue?vue&type=script&lang=ts&"
import style0 from "./TrustPilot.vue?vue&type=style&index=0&id=7698e7ca&prod&lang=scss&scoped=true&"
import style1 from "./TrustPilot.vue?vue&type=style&index=1&id=7698e7ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7698e7ca",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TrustPilotFeatured: require('/var/www/components/TrustPilotFeatured.vue').default})
